import { removeEmptyEntries } from "@lib-shared/lib";
import Messages from "core/constants/messages";

const getErrorMessage = (error: any, defaultMessage: string | null = null) => {
    const response = error?.response;

    const errors = [
        response?.data?.errorDescription,
        response?.data?.error,
        response?.data?.errorResponse?.errorDescription,
        response?.data?.errorResponse?.error,
        response?.statusText,
        defaultMessage ?? Messages.apiError
    ];

    return removeEmptyEntries(errors)[0];
}

export default getErrorMessage;
